<template>
    <div class="goods-list">
            <!-- 配件列表 -->
        <div class="parts-list">
            <div class="parts-head" ref="tableHead">
                <ul class="teble-head">
                    <li class="oecode">OE号
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'oecode1' }"
                                @click="handleSort('oecode', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'oecode2' }"
                                @click="handleSort('oecode', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="goods_name">商品名称
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'goods_name1' }"
                                @click="handleSort('goods_name', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'goods_name2' }"
                                @click="handleSort('goods_name', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="sccode">生产编码
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'sccode1' }"
                                @click="handleSort('sccode', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'sccode2' }"
                                @click="handleSort('sccode', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="oenaturebrand">配件品牌
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'oenaturebrand1' }"
                                @click="handleSort('oenaturebrand', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'oenaturebrand2' }"
                                @click="handleSort('oenaturebrand', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="goods_storage">库存
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'goods_storage1' }"
                                @click="handleSort('goods_storage', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'goods_storage2' }"
                                @click="handleSort('goods_storage', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="goods_price">订货价
                        <div class="ico">
                            <i
                                class="el-icon-caret-top"
                                :class="{ active: acSort == 'goods_price1' }"
                                @click="handleSort('goods_price', 1)"
                            ></i>
                            <i
                                class="el-icon-caret-bottom"
                                :class="{ active: acSort == 'goods_price2' }"
                                @click="handleSort('goods_price', 2)"
                            ></i>
                        </div>
                    </li>
                    <li class="spec">规格</li>
                    <li class="goods_num">订货数量</li>
                    <li class="handle-box">操作</li>
                </ul>
            </div>
            <div class="goods-body">
                <ul>
                    <li 
                        class="part-list" 
                        v-for="(goods, index) in goodsList" 
                        :key="index"
                    >
                        <div class="part-row">
                            <div class="watermark-text watermark-text2"> {{ $store.state.nickname||$store.state.member_name||"" }}  {{ $store.state.member_id }} </div>
                            <div class="isOe" @click.stop="showGoodsInfo(goods)">
                                <div class="isOe-left">
                                    <div class="isOe-top">
                                        <div class="name">{{ goods.oenaturebrand }}</div>
                                        <div class="number">
                                            {{ goods.oecode }}
                                        </div>
                                        <HnwCopy :data="goods.oecode"></HnwCopy>
                                        <div class="tag-icon" v-if="goods.isExchange">
                                            互
                                        </div>
                                    </div>
                                    <div class="vehicleModel" v-if="goods.vehicletype">车型：{{ goods.vehicletype }}</div>
                                </div>
                                <div class="watermark-text"> {{ $store.state.nickname||$store.state.member_name||"" }}  {{ $store.state.member_id }}</div>
                            </div>
                            <div @click.stop="showGoodsInfo(goods)" class="goods_name" :title="goods.goods_name">
                                <div class="ellipsis-text">{{ goods.goods_name }}</div>
                                <div class="product-top">
                                    <img class="cx-icon" src="../assets/common/cuxiao.png" v-if="goods.isMcx" alt="" srcset="">
                                    <div v-if="goods.goods_commend==71" class="dis-good-tips-small">
                                        {{goods.roiZ}} 折
                                    </div>
                                    <div v-if="goods.goodsPosImg" class="share-btn" @click.stop="shareGoods(goods)">
                                        <img src="../assets/common/分享.jpg" alt="" srcset="">
                                    </div>
                                </div>
                                <div class="delivery-time red" v-if="goods.final_delivery_time">
                                    {{ goods.final_delivery_time}}
                                </div>
                                <div class="delivery-time red" v-if="goods.new_arrival_time">
                                    {{ goods.new_arrival_time}}
                                </div>
                            </div>
                            
                            <div class="sccode" :title="goods.sccode">
                                <div class="ellipsis-text">{{ goods.sccode }}</div>
                                <HnwCopy :data="goods.sccode"></HnwCopy>
                            </div>
        
                            <div class="oenaturebrand" :title="goods.oenaturebrand" :class="{'selfBrand': goods.hnw_self}">
                                {{ goods.oenaturebrand }}
                                <span class="hnw-self-brand" v-if="goods.hnw_self">
                                    自主品牌
                                </span>
                            </div>
                            <div class="goods_storage" :class="{'disabled-color':goods.goods_storage==0}">
                                <template v-if="$store.state.store_id.includes('1780')">
                                    <div class="goods-location">
                                        <template >
                                            <div style="font-size:14px;">丹阳:
                                                <span >{{goods.goods_stcids}}</span>
                                            </div>
                                            <div style="font-size:12px;">上海:
                                                <span >{{goods.sh_storage}}</span>
                                            </div>
                                        </template>
                                    </div>
                                    <div v-if="$store.state.member_id.includes('1780')" class="loca-btn" @click.stop="openAll(goods)"><span>货位详情</span></div>
                                </template>
                                <div v-else>
                                    <span v-if="$store.state.look_inv==1">{{goods.goods_storage}}</span>
                                    <span v-else :class="{'disabled-color':goods.goods_storage==0}">{{goods.goods_storage>0?"有货":"无货"}}</span>
                                    <div v-if="goods.cangTip" class="goods-cangTip">{{goods.cangTip}}</div>
                                </div>
                                <div class="arrival-btn-box" v-if="arrivedState == '2'">
                                    <el-button 
                                        :disabled="goods.isArrivalRemind"
                                        type="primary" 
                                        size="mini" 
                                        @click.stop="addArrivalRemind(goods)"
                                    >{{goods.isArrivalRemind ? '已添加' : '添加提醒'}}</el-button>
                                </div>
                            </div>
                            
        
                            <div class="goods_price">
                                ¥ {{ goods.goods_price }}
                                <span v-if="goods.brand_ratio_price">({{goods.brand_ratio_price}})</span>
                            </div>
        
                            <div class="spec">
                                {{ goods.spec }}
                            </div>
        
                            <div class="goods_num" @click.stop>
                                <el-input-number 
                                    v-if="$store.state.zero_buy==1" 
                                    v-model="goods.goods_num" 
                                    :min="1" 
                                    size="mini"
                                ></el-input-number>
                                <el-input-number 
                                    v-else 
                                    v-model="goods.goods_num" 
                                    @change="impueNumChange(goods)" 
                                    :min="1" 
                                    size="mini"
                                ></el-input-number>
                            </div>
        
                            <div class="handle-box">
                                <div 
                                    class="add-btn" 
                                    :class="{'ycg-btn':goods.goods_storage==0}" 
                                    @click.stop="joinCart(goods)"
                                >
                                    {{goods.goods_storage>0?'加入购物车':'加入预购单'}}
                                </div>
                                <div class="addition">
                                    <span v-if="goods.cartNum">
                                        已添加 {{goods.cartNum}} {{goods.oecompany || "个"}}
                                        <el-popover
                                            placement="left"
                                            trigger="click"
                                            width="300"
                                            popper-class="cart-popover"
                                        >
                                            <el-table 
                                                :data="goods.cartList || []" 
                                                style="width: 100%" 
                                                :show-header="true"
                                            >
                                                <el-table-column 
                                                    prop="buyer_name" 
                                                    label="操作员" 
                                                    align="center"
                                                ></el-table-column>
                                                <el-table-column 
                                                    prop="goods_num" 
                                                    label="购物车数量" 
                                                    align="center"
                                                ></el-table-column>
                                            </el-table>
                                            <img 
                                                slot="reference" 
                                                src="../assets/common/cart-list-i.png" 
                                                alt="" 
                                                srcset=""
                                                style="cursor: pointer;width: 10px;"
                                            >
                                        </el-popover>
                                    </span>
                                </div>
                                <el-popover
                                    placement="left"
                                    width="260"
                                    popper-class="pop-replace-list"
                                    v-model="goods.replacePopVis"
                                    trigger="click"
                                >
                                    <div class="pop-close" @click.stop="goods.replacePopVis=false">
                                        <i class="el-icon-close"></i>
                                    </div>
                                    <el-table :border="false" class="replace-table" :data="buyStoreList" height="300">
                                        <el-table-column width="60" type="index" label="序号"></el-table-column>
                                        <el-table-column width="120" property="oecode" label="互换件号">
                                            <template slot-scope="scope1">
                                                <span>{{scope1.row.oecode}}</span>
                                                <HnwCopy :data="scope1.row.oecode"></HnwCopy>
                                            </template>
                                        </el-table-column>
                                        <el-table-column width="80" property="address" label="操作">
                                            <template slot-scope="scope1">
                                                <span class="show-btn" style="cursor: pointer" v-if="scope1.row.goods_id" @click="toSearch(scope1.row)">
                                                    在售
                                                </span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <div 
                                        class="replace-btn" 
                                        @click.stop="showChangeParts(goods)" 
                                        type="text" 
                                        slot="reference" 
                                        v-if="goods.exchange && goods.exchange.length>0"
                                    >
                                        查看互换件
                                    </div>
                                </el-popover>
                            </div>
                        </div>
                        
                        <!-- 历史购买记录 -->
                        <div class="goods-ex-msg" v-if="goods.orderInfo">
                            <div class="buyHis" @click.stop="readHisList(goods.goods_id)">
                                您最近一次购买：
                                <span>
                                    {{$hnwTools.formatDateTime(goods.orderInfo.add_time,'ymd')}}
                                </span>
                                <span>
                                    {{goods.orderInfo.goods_num?goods.orderInfo.goods_num:0}} 个
                                </span>
                                <span class="readMore">
                                    更多
                                </span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            
            <div class="pages">
                <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page="currentPage"
                    background
                    :page-sizes="[10, 20, 30, 50,100]"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, sizes, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>

        <!-- 货位详情弹窗 -->
        <el-dialog title="货位详情"
            :visible.sync="openAllotion"
            width="50%"
        >
            <div class="alltion">
                <div>OE号</div>
                <div>仓库</div>
                <div>货架</div>
                <div>数量</div>
                <div v-for="(item, index) in goodsAllotion.dy.list" :key="index">
                    <div>{{ goodsAllotion.dy.title }}</div>
                    <div>{{ item.store_name }}</div>
                    <div>{{ item.position }}</div>
                    <div>{{ item.num }}</div>
                </div>
                <div v-for="(item, index) in goodsAllotion.sh.list" :key="index">
                    <div>{{ goodsAllotion.sh.title }}</div>
                    <div>{{ item.store_name }}</div>
                    <div>{{ item.position }}</div>
                    <div>{{ item.num }}</div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="openAllotion = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="openAllotion = false">确 定</el-button>
            </span>
        </el-dialog>
        
        <!-- 历史购买记录弹窗 -->
        <!-- 历史购买记录弹窗 -->
        <el-dialog title="历史购买记录" :visible.sync="hisVis" center width="800px">
            <div class="his-list">
                <div class="list-head">
                    <div>购买时间</div>
                    <div>发货时间</div>
                    <div>购买人</div>
                    <div class="col-100">价格</div>
                    <div class="col-100">购买个数</div>
                    <div class="col-100">订单状态</div>
                </div>
                <div class="list-body">
                    <div class="row" v-for="(his,index) in gooodsHisList" :key="index">
                        <div>{{$hnwTools.formatDateTime(his.add_time,'ymd')}}</div>
                        <div>{{$hnwTools.formatDateTime(his.delay_time,'ymd')||"无"}}</div>
                        <div>{{his.member_name}}</div>
                        <div class="col-100">{{his.goods_price}}</div>
                        <div class="col-100">{{his.goods_num}}</div>
                        <div class="col-100">{{$hnwTools.getOrderStateText(his.order_state)}}</div>
                    </div>
                </div>
            </div>
        </el-dialog>

     </div>  
</template>

<script>
import HnwCopy from './HnwCopy.vue';

export default {
    name: 'GoodsList',
    components: {
        HnwCopy
    },
    props: {
        goodsList: {
            type: Array,
            default: () => []
        },
        total: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 10
        },
        acSort: {
            type: String,
            default: ''
        },
        arrivedState: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            openAllotion: false,
            goodsAllotion: {
                dy: {
                    title: "丹阳",
                    list: []
                },
                sh: {
                    title: "上海",
                    list: []
                }
            },
            hisVis: false,
            gooodsHisList: [],
            buyStoreList: []
        };
    },
    methods: {
        // 排序处理 - 发送给父组件
        handleSort(field, order) {
            this.$emit('sort', { field, order });
        },
        
        // 分页处理 - 发送给父组件
        handleCurrentChange(val) {
            this.$emit('page-change', val);
        },
        handleSizeChange(val) {
            this.$emit('handleSizeChange', val);
        },

        // 显示商品详情
        showGoodsInfo(goods) {
            goods.preRou = "今日到货";
            localStorage.setItem("hnw-web-item-data", JSON.stringify(goods));
            this.$router.push("/brand/info");
        },
        
        // 分享商品
        shareGoods(goods) {
            this.$message.info('分享商品');
        },
        
        // 输入数量变化
        impueNumChange(goods) {
            if (isNaN(goods.goods_num)) {
                this.$nextTick(() => {
                    this.$set(goods, "goods_num", 1);
                });
            }
            if (goods.goods_storage > 0 && goods.goods_num > goods.goods_storage) {
                this.$nextTick(() => {
                    goods.goods_num = goods.goods_storage;
                });
                return this.$store.commit("UpDateState", { invDia: true });
            }
        },
        
        // 添加到购物车
        async joinCart(carItem) {
            const tidySubPart = async () => {
                let carMessage = {
                    goods_id: carItem.goods_id,
                    sccode: carItem.sccode,
                    oecode: carItem.oecode,
                    goods_name: carItem.goods_name,
                    goods_price: carItem.goods_price,
                    goods_num: carItem.goods_num,
                    goods_storage: carItem.goods_storage,
                    store_id: carItem.store_id,
                    store_name: carItem.store_name,
                    cart_type: "1"
                };
                
                let res = await this.$api.joinCart([carMessage]);
                if(res){
                    carItem.cartNum = Number(carItem.cartNum) + Number(carItem.goods_num);
                }
            };

            if (this.$isCompany()) {
                if (this.$store.state.zero_buy != 1) {
                    if (carItem.goods_storage < 1) {
                    } else if (
                        carItem.goods_num + Number(carItem.cartNum) >
                        carItem.goods_storage
                    ) {
                        return this.$store.commit("UpDateState", { invDia: true });
                    }
                }
                if (carItem.goods_storage < 1 && Number(carItem.cartNum) > 0) {
                    tidySubPart();
                } else {
                    tidySubPart();
                }
            }
        },
        
        // 查看互换件
        async showChangeParts(epcPart) {
            try {
                this.goodsList.forEach(item=>{
                    item.replacePopVis = false
                })
            } catch (error) {
                console.log(error);
            }
            
            if(epcPart.exchange&&epcPart.exchange.length>0){
                let oem =  epcPart.exchange.join(",")
                this.buyStoreList = []
                let res = await this.$api.getBatchSearch({
                oem
                })
            
                if(res&&res.length>0){
                let addStr = ''
                res.forEach(goods=>{
                    if(!addStr.includes(goods.oecode)){
                    this.buyStoreList.push({
                        goods_id:goods.goods_id,
                        oecode:goods.oecode
                    })
                    addStr += goods.oecode+","
                    }
                })
                }
                epcPart.exchange.forEach(oecode=>{
                let has = this.buyStoreList.some(goods=>goods.oecode==oecode)
                if(!has){
                    this.buyStoreList.push({
                    oecode
                    })
                }
                })
                
                epcPart.replacePopVis = true
            }
        },
        
        toSearch(goods) {
            goods.replacePopVis = false
        },
        
        // 读取历史购买记录
        async readHisList(goods_id) {
            try {
                let res = await this.$api.getGoodsRecord(goods_id);
                this.gooodsHisList = res;
                this.hisVis = true;
            } catch (error) {
                console.error('获取历史购买记录失败:', error);
                this.$message.error('获取历史购买记录失败');
            }
        },
        
        // 显示货位详情
        async openAll(data) {
            if(this.$store.state.member_id.includes('1780')){ 
                let allotion = await this.$http(`${this.$axios.defaults.baseURL.replace("web",'public')}index.php?act=search&op=stockInfo`,{skuId:data.skuId})
                this.goodsAllotion = this.$hnwTools.getAllotion(allotion) 
            }
            this.openAllotion = true
        },
        
        // 添加到货提醒
        async addArrivalRemind(goods) {
            try {
                let params = {
                    member_name: this.$store.state.member_name,
                    member_id: this.$store.state.member_id,
                    store_id:  this.$store.state.store_id,
                    store_name: this.$store.state.store_name,
                    goods_id: goods.goods_id,
                    arrived_state: this.arrivedState
                };
                let res = await this.$api.insert_goods_arrival(params);
                if (res ) {
                    this.$message.success('添加提醒成功');
                    goods.isArrivalRemind = true
                } else {
                    this.$message.error(res && res.msg || '添加提醒失败');
                }
            } catch (error) {
                console.error('添加提醒失败:', error);
                this.$message.error('添加提醒失败');
            }
        },
        
        // 添加催交期
        async addUrge(goods) {
            try {
                let params = {
                    member_name: this.$store.state.member_name,
                    member_id: this.$store.state.member_id,
                    store_id: this.$store.state.store_id,
                    store_name: this.$store.state.store_name,
                    goods_id: goods.goods_id,
                    arrived_state: this.arrivedState
                };
                let res = await this.$api.insert_goods_urge(params);
                if (res ) {
                    this.$message.success('催交期添加成功');
                } else {
                    this.$message.error(res && res.msg || '催交期添加失败');
                }
            } catch (error) {
                console.error('催交期添加失败:', error);
                this.$message.error('催交期添加失败');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.goods-list{
    width: 100%;
    .parts-list{
            
        background: #fff;
        // 表头样式
            .parts-head {
                height: 40px;
                background: #c4c9cc;
                .teble-head {
                    display: flex;
                    li {
                        display: flex;
                        height: 40px;
                        justify-content: center;
                        align-items: center;
                        position: relative;
                        color: #666;
                        &.oecode {
                            min-width: 250px;
                            max-width: 250px;
                        }
                        &.goods_name {
                            min-width: 180px;
                            max-width: 180px;
                        }
                        &.sccode {
                            min-width: 120px;
                            max-width: 120px;
                        }
                        &.oenaturebrand {
                            min-width: 120px;
                            max-width: 120px;
                        }
                        &.goods_storage {
                            width: 150px;
                        }
                        &.goods_price {
                            width: 82px;
                            position: relative;
                        }
                        .ico {
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            align-items: center;
                            margin-left: 5px;
                            > i {
                                cursor: pointer;
                                font-size: 12px;
                            }
                            i:hover {
                                transform: scale(1.5);
                                color: #3E84D6;
                            }
                            .el-icon-caret-top {
                                position: relative;
                                top: 3px;
                            }
                            .el-icon-caret-bottom {
                                position: relative;
                                top: -3px;
                            }
                            .active {
                                color: #3E84D6;
                            }
                        }
                        &.spec {
                            width: 90px;
                        }
                        &.goods_num {
                            width: 114px;
                        }
                        &.handle-box {
                            width: 86px;
                        }
                    }
                }
            }

            .goods-body {
                display: flex;
                box-sizing: border-box;
                position: relative;
                box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.13);
                margin-bottom: 20px;
                > ul {
                    width: 100%;
                }
                .part-list {
                    &.isAll {
                        height: auto;
                    }
                }
                .part-list:nth-child(2n) {
                    background: #f7f7f7;
                }
                
                .part-row {
                    display: flex;
                    position: relative;
                    .watermark-text{
                        position: absolute;
                        left: 20%;
                        top: 20%;
                    }
                    .watermark-text2{
                        left: 68%;
                    }
                    >div{
                        box-sizing: border-box;
                    }
                    .isOe {
                        position: relative;
                        width: 250px;
                        border-right: 1px solid #e3e4ea;
                        display: flex;
                        justify-content: space-between;
                        
                        .isOe-left {
                            width: 98%;
                            .isOe-top {
                                display: flex;
                                margin-top: 14px;
                                margin-bottom: 10px;
                                margin-left: 10px;
                                position: relative;
                                .hnw-copy{
                                    position: absolute;
                                    right: 36px;
                                    top: -6px;
                                }
                                .name {
                                    width: 48px;
                                    height: 20px;
                                    background-color: #3E84D6;
                                    font-size: 12px;
                                    text-align: center;
                                    line-height: 20px;
                                    color: #fff;
                                }
                                .number {
                                    cursor: pointer;
                                    max-width: 100px;
                                    margin-left: 5px;
                                    margin-top: 2px;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                    padding-top: 0;
                                    color: #333;
                                }
                                .tag-icon {
                                    display: flex;
                                    align-items: center;
                                    transform: scale(0.7);
                                    justify-content: center;
                                    width: 20px;
                                    height: 20px;
                                    background: #3E84D6;
                                    color: #fff;
                                    border-radius: 50%;
                                    font-size: 12px;
                                    position: relative;
                                    top: -8px;
                                    left: 2px;
                                }
                            }
                            .vehicleModel {
                                margin: 0 0 0 10px;
                                max-width: 230px;
                                box-sizing: border-box;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                cursor: pointer;
                                font-size: 14px;
                                color: #999;
                            }
                        }
                    }

                    .goods_name {
                        width: 180px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        position: relative;
                        gap: 2px;
                        .ellipsis-text{
                            width: 94%;
                            height: 16px;
                            text-align: center;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .product-top{
                            position: absolute;
                            right: 0px;
                            top: 0px;
                            display: flex;
                            align-items: center;
                            padding-right: 5px;
                            >div{
                                cursor: pointer;
                            }
                            .dis-good-tips-small {
                                background: url(../assets/newHome/折扣.png);
                                background-size: 40px 20px;
                                width: 40px;
                                height: 20px;
                                margin-left: 6px;
                                text-align: center;
                                line-height: 20px;
                                font-family: Source Han Sans CN;
                                font-weight: 500;
                                font-size: 12px;
                                color: #FFFFFF;
                                z-index: 99;
                            }
                            .cx-icon{
                                width: 22px;
                                margin-left: 8px;
                            }
                        }
                        .share-btn{
                            line-height: 1;
                            margin-left: 6px;
                            
                            img{
                                width: 20px;
                            }
                        }
                        .delivery-time{
                            
                            
                        }
                    }

                    .sccode {
                        width: 120px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        position: relative;
                        .ellipsis-text{
                            width: 94%;
                            text-align: center;
                            height: 16px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .hnw-copy{
                            position: absolute;
                            right: 20px;
                            top: 8px;
                        }
                    }
                    
                    .oenaturebrand {
                        overflow: hidden;
                        width: 120px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        text-overflow: ellipsis;
                        position: relative;
                        .hnw-self-brand {
                            position: absolute;
                            bottom: -25px;
                            left: 50%;
                            transform: translateX(-50%);
                            color: #ff7519;
                        }
                    }
                    
                    // 自选品牌
                    .selfBrand {
                        background: #d9ecff;
                        border-bottom: 1px solid #ccc;
                    }
                    
                    .goods_storage {
                        width: 150px;
                        box-sizing: border-box;
                        border-right: 1px solid #e3e4ea;
                        text-align: center;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        padding: 5px 0;
                        .goods-location{
                            >div{
                                color: #2473FF;
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                margin-right: 3px;
                            }
                        }
                        .loca-btn{
                            cursor: pointer;
                            padding: 1px;
                            color: #fff;
                            background: #FFAB00;
                            width: 66px;
                            text-align: center;
                            margin: 2px auto 0;
                        }
                        .goods-cangTip{
                            color: #F94F4C;
                            font-size: 12px;
                            margin-left: 5px;
                            font-weight: bold;
                        }
                    }
                    
                    .arrival-btn-box {
                        padding-top: 2px;
                        width: 100%;
                        box-sizing: border-box;
                        // border-right: 1px solid #e3e4ea;
                        display: flex;
                        
                        justify-content: center;
                        align-items: center;
                        // padding: 5px;
                        // gap: 5px;
                        .el-button {
                            padding: 4px 8px;
                            font-size: 12px;
                        }
                    }
                    
                    .goods_price {
                        position: relative;
                        width: 82px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        text-overflow: ellipsis;
                        .watermark-text{
                            right: 0px !important;
                            top: -4px;
                        }
                        span {
                            position: relative;
                            top: 1px;
                        }
                    }

                    .spec {
                        overflow: hidden;
                        width: 90px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        text-overflow: ellipsis;
                    }

                    .goods_num {
                        width: 114px;
                        height: 69px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border-right: 1px solid #e3e4ea;
                        position: relative;
                        .el-input-number {
                            // margin: 0 0px 0 10px;
                            width: 100px;
                        }
                        .goods-Fcl-tit {
                            position: absolute;
                            left: 50%;
                            transform: translateX(-50%);
                            bottom: 2px;
                            font-size: 12px;
                            line-height: 12px;
                            width: 120px;
                            text-align: center;
                            color: #999;
                        }
                        .red {
                            color: red;
                        }
                    }

                    .handle-box {
                        position: relative;
                        box-sizing: border-box;
                        padding: 5px 0;
                        width: 86px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        .addition {
                            font-size: 14px;
                            color: #999;
                            margin: 3px 0;
                            >span{
                                // display: flex;
                                // align-items: center;
                                // justify-content: center;
                            }
                        }
                        .replace-btn {
                            color: #3E84D6;
                            cursor: pointer;
                        }
                        .add-btn {
                            width: 80px;
                            height: 22px;
                            padding: 0;
                            color: #59a8f8;
                            font-size: 14px;
                            font-weight: 400;
                            line-height: 20px;
                            border-radius: 0px;
                            text-align: center;
                            cursor: pointer;
                        }
                        .add-btn:active{
                            transform: scale(1.1);
                        }
                        .ycg-btn {
                            background: #f5f5f5;
                            color: #999;
                            border: 1px solid #dcdfe6;
                        }
                    }
                }
                
                .goods-ex-msg {
                    display: flex;
                    border-top: 1px solid #e3e4ea;
                    justify-content: flex-end;
                    align-items: center;
                    line-height: 30px;
                    height: 30px;
                    .buyHis {
                        cursor: pointer;
                        text-align: right;
                        padding: 0 5px;
                        color: red;
                        font-size: 12px;
                        > span {
                            margin-right: 10px;
                            align-items: center;
                        }
                        .readMore {
                            cursor: pointer;
                        }
                    }
                }
            }
        
        .pages{
            text-align: right;
            padding: 10px;
        }
    }
}

.alltion{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    padding: 10px;
    >div{
        padding: 5px;
        text-align: center;
        border-bottom: 1px solid #e3e4ea;
        &:nth-child(-n+4){
            font-weight: bold;
            background: #f7f7f7;
        }
    }
    .history-table{
        // /deep/ .el-table__header th{
        //     background: #f7f7f7;
        //     font-weight: bold;
        // }
    }
    // 历史购买记录样式
    .his-list {
        .list-head {
            display: flex;
            background: #f5f5f5;
            padding: 10px 0;
            div {
                flex: 1;
                text-align: center;
                font-weight: bold;
                &.col-100 {
                    width: 100px;
                }
            }
        }
        .list-body {
            .row {
                display: flex;
                padding: 10px 0;
                border-bottom: 1px solid #f0f0f0;
                div {
                    flex: 1;
                    text-align: center;
                    &.col-100 {
                        width: 100px;
                    }
                }
            }
        }
    }
    .replace-table{
        // /deep/ .el-table__header th{
        //     background: #f7f7f7;
        //     font-weight: bold;
        // }
    }
    
    .pop-replace-list{
        .pop-close{
            position: absolute;
            right: 10px;
            top: 10px;
            cursor: pointer;
            i{
                font-size: 20px;
                color: #999;
            }
        }
    }
    
    .red{
        color: red;
    }
    
    .disabled-color{
        color: #999;
    }
}


</style>